import { useRef } from "react";
import { generateUuid } from "../utils/utils";

export const useCustomFormWcagAttributes = ({
  fieldName,
}: {
  fieldName: string;
}) => {
  const uniqueIdForAriaRequired = useRef(`${fieldName}-${generateUuid()}`);
  const uniqueId = useRef(`${fieldName}-${generateUuid()}`);

  return {
    uniqueIdForAriaRequired: uniqueIdForAriaRequired.current,
    uniqueId: uniqueId.current,
  };
};
